import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import LocalEvents from './pages/LocalEvents';
import Classifieds from './pages/Classifieds';
import Profile from './pages/Profile';
import AboutUs from './pages/AboutUs';
import CreateListing from './pages/CreateListing';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<LocalEvents />} />
          <Route path="classifieds" element={<Classifieds />} />
          <Route path="profile" element={<Profile />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="create-listing" element={<CreateListing />} />
          <Route path="admin" element={<AdminDashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
